import { ajax } from '@/util/ajax'
const BASE_URL = '/gateway/platform-lmsapi/customer'

const CustomerApi = {
  getCustomerOptInData (input, success) {
    return ajax.get(
      `${BASE_URL}/opt-in/list`,
      input,
      success
    )
  },
  replaceCustomerOptInData (optInData, success, failure) {
    return ajax.put(
      `${BASE_URL}/opt-in/update`,
      optInData,
      success,
      failure
    )
  },
  searchCustomer (data, success, failure) {
    return ajax.get(
      `${BASE_URL}/search`,
      data,
      success,
      failure
    )
  }
}
export { CustomerApi }
